import React from "react";

const HEADER_BAR_STYLE = {
  width: "100%",
  height: "40px",
  flexShrink: 0,
  background: "#FF4D4F",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

const TEXT_STYLE = {
  color: "#FFF",
  fontFamily: "Inter, sans-serif",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "20px",
  marginRight: "8px",
};

const BUTTON_STYLE = {
  color: "#FFF",
  fontFamily: "Inter, sans-serif",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: 500,
  lineHeight: "normal",
  textDecorationLine: "underline",
  textDecorationStyle: "solid",
  textDecorationSkipInk: "none",
  textDecorationThickness: "auto",
  textUnderlineOffset: "auto",
  textUnderlinePosition: "from-font",
  background: "none",
  border: "none",
  cursor: "pointer",
  padding: 0,
};

function HeaderAlertBar({ acceptChat, loading, onAcceptChats }) {
  if (acceptChat) return null;
  return (
    <div style={HEADER_BAR_STYLE}>
      <span style={TEXT_STYLE}>You are currently not accepting chats</span>
      <button style={BUTTON_STYLE} onClick={onAcceptChats} disabled={loading}>
        {loading ? "Updating..." : "Start Accepting Chats"}
      </button>
    </div>
  );
}

export default HeaderAlertBar; 